<template lang="pug">
  label.checkbox
    input.checkbox__input(
      type="checkbox"
      :id="id"
      :value="modelValue"
      @change="onChange"
      :checked="checked"
    )
    .checkbox__box
    slot
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export default defineNuxtComponent({
    name: 'InputCheckbox',

    props: {
      id: {
        type: String as PropType<string>,
        required: true,
      },
      modelValue: {
        type: Boolean as PropType<boolean>,
        required: true,
      },
    },

    computed: {
      checked() {
        return this.modelValue;
      },
    },

    methods: {
      onChange(_event: any) {
        this.$emit('update:modelValue', !this.modelValue);
        this.$emit('input', !this.modelValue);
      },
    },
  });
</script>

<style lang="scss" scoped>
  .checkbox {
    display: inline-block;
    @include fontSmallTextBtn;
    font-weight: 400;
    padding-left: 32px;
    position: relative;
    cursor: pointer;
    user-select: none;

    @include hover {
      .checkbox__box {
        border-color: #3a74f6;
      }
    }

    &__input {
      appearance: none;
      position: absolute;
      // polyfill
      width: 1px;
      height: 1px;
      overflow: hidden;
      clip: rect(0 0 0 0);
      outline: none;

      &:checked {
        & + .checkbox__box {
          border-color: #3a74f6;
          background-color: #3a74f6;

          &:before {
            // background-color: #3A74F6;
            @include okMask;
            background: #fff;
          }
        }
      }
    }

    &__box {
      position: absolute;
      left: 0;
      top: 2px;
      width: 16px;
      height: 16px;
      border: 1px solid #969698;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;

      &:before {
        content: '';
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: transparent;
      }
    }
  }
</style>
